/**
 * True when the app is served from a QA host. All QA hostnames follow
 * the `testsystem-` prefix convention (e.g.
 * testsystem-tagebuch.kiju-home.de, testsystem-dashboard.kiju-home.de),
 * so no configuration is needed -- production hosts and local dev never
 * match.
 */
export const isTestSystem = () =>
	window.location.hostname.startsWith("testsystem-");
